export default {
  methods: {
    setFromTextInput(newValue) {
      this.from.textInput = this.ymdToInput(newValue);
      this.from.selected = newValue;
      const tmp = this.from.selected.split('-');
      this.setCalendarMonth([parseInt(tmp[0]), parseInt(tmp[1])]);
    },
    setToTextInput() {
      let tmp = this.to.selected.split('-');
      if (!this.isEqualArray(this.calendarMonth, [parseInt(tmp[0]), parseInt(tmp[1])])) {
        tmp = this.dateToYmd(this.ymdToDate(this.to.selected, 0, 0, 0)).split('-');
        this.setCalendarMonth([parseInt(tmp[0]), parseInt(tmp[1])]);
      }
    }
  }
};
